"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_MESSAGE = void 0;
exports["default"] = sendMessage;
var SEND_MESSAGE = 'WEB_CHAT/SEND_MESSAGE';
exports.SEND_MESSAGE = SEND_MESSAGE;

function sendMessage(text, method) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      channelData = _ref.channelData;

  return {
    type: SEND_MESSAGE,
    payload: {
      channelData: channelData,
      method: method,
      text: text
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX01FU1NBR0UiLCJzZW5kTWVzc2FnZSIsInRleHQiLCJtZXRob2QiLCJjaGFubmVsRGF0YSIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2VuZE1lc3NhZ2UuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9NRVNTQUdFID0gJ1dFQl9DSEFUL1NFTkRfTUVTU0FHRSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNlbmRNZXNzYWdlKHRleHQsIG1ldGhvZCwgeyBjaGFubmVsRGF0YSB9ID0ge30pIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRU5EX01FU1NBR0UsXG4gICAgcGF5bG9hZDogeyBjaGFubmVsRGF0YSwgbWV0aG9kLCB0ZXh0IH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VORF9NRVNTQUdFIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxZQUFZLEdBQUcsdUJBQXJCOzs7QUFFZSxTQUFTQyxXQUFULENBQXFCQyxJQUFyQixFQUEyQkMsTUFBM0IsRUFBeUQ7RUFBQSwrRUFBSixFQUFJO0VBQUEsSUFBcEJDLFdBQW9CLFFBQXBCQSxXQUFvQjs7RUFDdEUsT0FBTztJQUNMQyxJQUFJLEVBQUVMLFlBREQ7SUFFTE0sT0FBTyxFQUFFO01BQUVGLFdBQVcsRUFBWEEsV0FBRjtNQUFlRCxNQUFNLEVBQU5BLE1BQWY7TUFBdUJELElBQUksRUFBSkE7SUFBdkI7RUFGSixDQUFQO0FBSUQifQ==